// import $ from 'jquery';

export const getPosition = el => {
  let x = 0;
  let y = 0;
  let elParam = el;
  while (elParam != null && (elParam.tagName || '').toLowerCase() !== 'html') {
    x += elParam.offsetLeft || 0;
    y += elParam.offsetTop || 0;
    elParam = elParam.parentElement;
  }

  return { x: parseInt(x, 10), y: parseInt(y, 10) };
};

export const scrollToById = (id, options = {}, delay = 10) => {
  const { detalY = 0 } = options;
  setTimeout(() => {
    const element = document.getElementById(id);
    if (!element) {
      return;
    }
    const y = element.getBoundingClientRect().top + window.pageYOffset + detalY;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }, delay);
};

export const screenClientSize = () => {
  const win = window;
  const doc = document;
  const docElem = doc.documentElement;
  const body = doc.getElementsByTagName('body')[0];
  const x = win.innerWidth || docElem.clientWidth || body.clientWidth;
  const y = win.innerHeight || docElem.clientHeight || body.clientHeight;
  return { clientWidth: x, clientHeight: y };
};

// function getOffset(el) {
//   let _x = 0;
//   let _y = 0;
//   while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
//     _x += el.offsetLeft - el.scrollLeft;
//     _y += el.offsetTop - el.scrollTop;
//     el = el.offsetParent;
//   }
//   return { top: _y, left: _x };
// }

// export const getVisibleWords = ele => {
//   // https://stackoverflow.com/questions/19356819/how-to-find-the-last-visible-word-position-in-a-text-container
//   ele = $(ele);
//   ele.html('<span>' + ele.html().replace(/ /g, '</span> <span>') + '</span>');
//   const words = Array.prototype.slice.call(ele.find('span'), 0).reverse();
//   // const lastWork = null;
//   let lastWorkIndex = 0;
//   for (let i = 0, c = words.length; i < c; i++) {
//     const w = $(words[i]);
//     const wBot = w.height() + w.offset().top;
//     const wLeft = w.offset().left;
//     const wRight = wLeft + w.width();
//     if (wBot <= ele.height() && wLeft <= ele.width() && wRight <= ele.width()) {
//       lastWorkIndex = i;
//       // lastWork = w.text();
//       break;
//     }
//   }
//   const visibleWords = words
//     .slice(lastWorkIndex, words.length)
//     .reverse()
//     .map(item => $(item).text())
//     .join(' ');
//   ele.html(ele.text());
//   return visibleWords;
// };
